import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { PrimaryButton } from '../../../UI/PrimaryButton'
import { colors } from '../../../../styles/colors'

const Container = styled.div`

display: flex;
align-items: center;
flex-wrap: wrap;

@media (max-width: 1299.98px) {
    flex-direction: column;
}
.counter-box {
    display: flex;
}
.counter {
    width: 10rem;
    background: none;
    border: none;
    outline: none;

    font-family: 'SF UI Text', sans-serif;
    font-weight: 400;
    font-size: 3.75rem;
    text-align: center;

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }

    :hover {
        color: ${colors.red};
        cursor: pointer;
    }
}
.counter-btn {
    background: ${colors.dark_blue};
    color: ${colors.white};
    cursor: pointer;
    padding: 2rem;
}
.add-to-cart-button {
    display: inline-block;
    margin: 0;

    @media (min-width: 1300px) {
        margin-left: 5rem;
    }
    @media(max-width: 1299.98px) {
        margin-top: 4rem;
    }
}
`

export const AddToCartBlock = ({ product_name, id, price, product_picture, count, setCount }) => {

    const dispatch = useDispatch()

    function handleCounter(value) {
        switch (value) {
            case '-':
                if (count > 1) {
                    setCount(count - 1)
                }
                break
            case '+':
                setCount(count + 1)
                break
            default:
                if (value < 1) {
                    setCount(1)
                } else {
                    setCount(value)
                }
        }
    }
    const handleAddToCart = () => {
        dispatch({ type: 'ADD_TO_CART', value: { product_name, count, id, price, product_picture } })
        alert('Товар добавлен в корзину')
        setCount(1)
    }

    return (
        <Container>
            <div className="counter-box">
                <p onClick={() => handleCounter('-')} className='counter-btn' >-</p>
                <input className='counter' type="number" onChange={e => handleCounter(+e.target.value)} value={count} />
                <p onClick={() => handleCounter('+')} className='counter-btn' >+</p>
            </div>
            <PrimaryButton className='add-to-cart-button' onClick={() => handleAddToCart()} >Добавить в корзину</PrimaryButton>
        </Container>
    )
}

